import React, { useState } from 'react'
// view components
import { Header } from 'components/Modals/ConfirmDeleteModal'
import { Button, Modal, BUTTON_LAYOUTS } from 'components/UI'
// hooks
import { useModalData } from 'hooks'
// constants
import { Modals } from 'constants/index'
// themes
import { ActionsWrapper, Content, ContentText } from 'themes/views/modals'

const ConfirmChangeParentPlanModal: React.FC = () => {
  const {
    hideModal,
    modalData: { isOpen, width, handleConfirm }
  } = useModalData({ modalType: Modals.CONFIRM_CHANGE_PARENT_PLAN_MODAL })

  const [isLoading, setLoading] = useState(false)

  const handleConfirmClick = async () => {
    try {
      setLoading(true)

      await handleConfirm()

      hideModal()
    } finally {
      setLoading(false)
    }
  }

  return (
    <Modal hideModal={hideModal} isOpen={isOpen} width={width}>
      <Header>Change Parent Plan</Header>
      <Content>
        <ContentText color={'inherit'} style={{ fontWeight: 500 }}>
          Selecting a new parent plan will remove all items selected in the current parent plan. Do you wish to proceed?
        </ContentText>
      </Content>
      <ActionsWrapper>
        <Button shadowLess isLoading={isLoading} layout={BUTTON_LAYOUTS.RED} onClick={handleConfirmClick}>
          Confirm
        </Button>
        <Button shadowLess layout={BUTTON_LAYOUTS.RED_INVERTED} onClick={hideModal}>
          Cancel
        </Button>
      </ActionsWrapper>
    </Modal>
  )
}

export default ConfirmChangeParentPlanModal
